function finiteNumber(value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

function clamp(value, minimum, maximum) {
  return Math.min(maximum, Math.max(minimum, value))
}

/**
 * Selection overlays are UI-only. Generation requests use these normalized
 * coordinates so no colored rectangle, label or handle is flattened into an
 * image sent to the model.
 */
export function normalizeSelection(selection = {}) {
  const x = clamp(finiteNumber(selection.x), 0, 1)
  const y = clamp(finiteNumber(selection.y), 0, 1)
  const width = clamp(finiteNumber(selection.width), 0, 1 - x)
  const height = clamp(finiteNumber(selection.height), 0, 1 - y)
  return { x, y, width, height }
}

export function selectionCoordinateText(selection, label = '目标区域') {
  const normalized = normalizeSelection(selection)
  const percent = value => (value * 100).toFixed(2)
  const right = normalized.x + normalized.width
  const bottom = normalized.y + normalized.height
  return `${label}的归一化坐标：左 ${percent(normalized.x)}%，上 ${percent(normalized.y)}%，右 ${percent(right)}%，下 ${percent(bottom)}%，宽 ${percent(normalized.width)}%，高 ${percent(normalized.height)}%`
}

export function selectionPixelBounds(selection, imageWidth, imageHeight) {
  const normalized = normalizeSelection(selection)
  const width = Math.max(1, Math.round(finiteNumber(imageWidth, 1)))
  const height = Math.max(1, Math.round(finiteNumber(imageHeight, 1)))
  const left = clamp(Math.floor(normalized.x * width), 0, width - 1)
  const top = clamp(Math.floor(normalized.y * height), 0, height - 1)
  const right = clamp(Math.ceil((normalized.x + normalized.width) * width), left + 1, width)
  const bottom = clamp(Math.ceil((normalized.y + normalized.height) * height), top + 1, height)
  return {
    left,
    top,
    right,
    bottom,
    width: right - left,
    height: bottom - top,
    centerX: left + (right - left) / 2,
    centerY: top + (bottom - top) / 2
  }
}

export function selectionListCoordinateText(selections = [], label = '处理区域') {
  return selections
    .map((selection, index) => selectionCoordinateText(selection, `${label} ${index + 1}`))
    .join('；')
}
